/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MappaPastoScuola } from './mappa-pasto-scuola';


export interface ServizioMensaConfigurazioneDTO { 
    servizio_id?: string;
    data_inizio?: string;
    data_fine?: string;
    gestione_manuale?: boolean;
    orario_massimo_per_annullamento_pasto?: string;
    tipo_pagamento?: ServizioMensaConfigurazioneDTOTipoPagamentoEnum;
    stato_ricarica_manuale?: ServizioMensaConfigurazioneDTOStatoRicaricaManualeEnum;
    soglia_promemoria_giorni?: number;
    soglia_sospensione_giorni?: number;
    soglia_promemoria_importo?: number;
    soglia_sospensione_importo?: number;
    assistenza_email?: string;
    mappa_pasti_scuola?: Array<MappaPastoScuola>;
}
export enum ServizioMensaConfigurazioneDTOTipoPagamentoEnum {
    NON_GESTITO = 'NON_GESTITO',
    MANUALE = 'MANUALE',
    PAGO_PA_RICARICHE = 'PAGO_PA_RICARICHE',
    PAGO_PA_RENDICONTAZIONE_E_RICARICHE = 'PAGO_PA_RENDICONTAZIONE_E_RICARICHE',
    PAGO_PA_RENDICONTAZIONE = 'PAGO_PA_RENDICONTAZIONE'
};
export enum ServizioMensaConfigurazioneDTOStatoRicaricaManualeEnum {
    ATTIVA = 'ATTIVA',
    NON_ATTIVA = 'NON_ATTIVA'
};



